import { oz } from '@weft/utils';
import { NewPromotionLineItemSchema } from './new-promotion-line-item-schema';

export const PromotionLineItemInputSchema = oz.object(NewPromotionLineItemSchema.shape)
  .partial()
  .required({ type: true })
  .openapi('PromotionLineItemInput');

export type PromotionLineItemInput = oz.infer<typeof PromotionLineItemInputSchema>;